import React from 'react';
import { useTranslation } from 'react-i18next';
import StepUI from './stepUI';
import './LessonStepsUI.scss';

const LessonStepsUI = ({ 
    stepsRecipe, 
    calcStepState,
    CurrentSelectedStep,
    setCurrentSelectedStep,
    handleOpenStepper,
}) => {
    const { t } = useTranslation();
    
   
    return (
        <div className="lessonStepsUI hideScrollbar ">
            {stepsRecipe.map((step, index) => {
                
                return (
                    <StepUI
                        key={index}
                        step={step}
                        index={index}
                        CurrentSelectedStep={CurrentSelectedStep}
                        setCurrentSelectedStep={setCurrentSelectedStep}
                        handleOpenStepper={handleOpenStepper}
                        calcStepState={calcStepState}
                        
                    />
                    );
                })}
        </div>
    );
};

export default LessonStepsUI;